/*
 * HDS card swatch behavior.
 * Hovering / focusing a .card-product__variant-swatch flips the corresponding
 * .card-product__variant-image to opaque (CSS reads `data-active-variant` on
 * the card and `data-active` on the image). Clicks navigate via the swatch
 * href to ?variant=<id> — no preventDefault here.
 *
 * Delegated globally; works for cards rendered by infinite scroll / AJAX swap.
 */
(() => {
  const SWATCH_SEL = '.card-product__variant-swatch';
  const CARD_SEL = '.card-product';

  const setActive = (card, variantId) => {
    if (!card) return;
    if (variantId) {
      card.setAttribute('data-active-variant', variantId);
    } else {
      card.removeAttribute('data-active-variant');
    }
    card.querySelectorAll('.card-product__variant-image').forEach((img) => {
      const match = variantId && img.getAttribute('data-variant-id') === String(variantId);
      img.setAttribute('data-active', match ? 'true' : 'false');
    });
    card.querySelectorAll(SWATCH_SEL).forEach((s) => {
      s.setAttribute('aria-current', s.getAttribute('data-variant-id') === String(variantId) ? 'true' : 'false');
    });
  };

  const onEnter = (e) => {
    const swatch = e.target.closest(SWATCH_SEL);
    if (!swatch) return;
    const card = swatch.closest(CARD_SEL);
    setActive(card, swatch.getAttribute('data-variant-id'));
  };

  const onLeave = (e) => {
    const swatch = e.target.closest(SWATCH_SEL);
    if (!swatch) return;
    const card = swatch.closest(CARD_SEL);
    if (!card) return;
    if (card.contains(e.relatedTarget)) return;
    // In split mode, the card's initial variant was set server-side. Restore it
    // instead of clearing, so the "current" swatch stays highlighted on hover-out.
    const initial = card.getAttribute('data-initial-variant');
    setActive(card, initial || null);
  };

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('mouseout', onLeave);
  document.addEventListener('focusout', onLeave);
})();
